/* eslint-disable no-void */

import * as vp from 'vopay';

import { useEffect, useState } from 'react';
import axios from 'axios';

import vopayApi from '../../services/api.config';

type HookProps = {
  api: vp.Api;
};

type ReturnTuple = [
  vp.ApiResponse | undefined,
  (requestParams: vp.AcceptAgreementRequest) => void,
  (requestParams: vp.AcceptAgreementRequest) => Promise<vp.ApiResponse>,
  () => void,
];

function usePostBankAccountConnection({ api }: HookProps): ReturnTuple {
  const source = axios.CancelToken.source();

  const [params, setParams] = useState<vp.AcceptAgreementRequest>();
  const [response, setResponse] = useState<vp.ApiResponse>();
  const [shouldSendRequest, setSendRequest] = useState(false);

  useEffect(() => {
    const sendRequest = async (requestParams: vp.AcceptAgreementRequest) => {
      const res = await api.postAcceptAgreement(requestParams, source);
      setResponse(res);
      setSendRequest(false);

      return () => {};
    };

    if (params && shouldSendRequest) void sendRequest(params);

    return () => {
      source.cancel();
    };
  }, [shouldSendRequest]);

  return [
    response,
    (requestParams: vp.AcceptAgreementRequest) => {
      setParams(requestParams);
      setSendRequest(true);
    },
    (requestParams: vp.AcceptAgreementRequest) => api.postAcceptAgreement(requestParams, source),
    () => {
      setResponse(undefined);
      setSendRequest(false);
    },
  ];
}

export default vopayApi.withApiHook<HookProps, ReturnTuple>(usePostBankAccountConnection);
